// A floor-size change on 保存: whether there is one, how it reads, and what
// it leaves outside. Items keep their metres; nothing here moves or scales.

// The backend stores floor_width / floor_height to the centimetre.
const cm = (v) => Math.round(v * 100) / 100;

export const sizeChanged = (saved, next) =>
  !!saved &&
  (cm(saved.width) !== cm(next.width) || cm(saved.height) !== cm(next.height));

/** "66.06 × 44": centimetres, trailing zeros dropped. */
export const formatSize = ({ width, height }) => `${cm(width)} × ${cm(height)}`;

export const sizeConfirmText = (saved, next) =>
  `場域尺寸已變更：${formatSize(saved)} m → ${formatSize(next)} m，確定保存？`;

// The same inclusive rectangle as the backend's _valid_polygon.
const inside = ({ width, height }, [x, y]) =>
  x >= 0 && x <= width && y >= 0 && y <= height;

const metres = (item) =>
  item.position_meters ? [item.position_meters.x, item.position_meters.y] : null;

const isZone = (s) => s.category === "防護區";

/** Per kind, how many points fall outside `size`; kinds with none are left out. */
export const outsideCounts = (
  size,
  { stations = [], symbols = [], areaVertices = [], tripwires = [] },
) => {
  const out = (points) =>
    points.filter((p) => p && !inside(size, p)).length;
  return [
    { label: "基站", count: out(stations.filter((s) => !isZone(s)).map(metres)) },
    { label: "物件", count: out(symbols.map(metres)) },
    { label: "防護區", count: out(stations.filter(isZone).map(metres)) },
    { label: "可行區域點", count: out(areaVertices) },
    { label: "越線端點", count: out(tripwires.flatMap((t) => t.points || [])) },
  ].filter((k) => k.count > 0);
};

export const outsideWarning = (counts) =>
  counts.length
    ? `下列項目會落在新尺寸之外（位置不變）：${counts
        .map((k) => `${k.label} ${k.count}`)
        .join("、")}`
    : null;

/**
 * The backend 400s a boundary_area with any vertex outside the floor. Only a
 * ring of 3+ points is sent; fewer is saved as null.
 */
export const areaOutside = (vertices, size) =>
  vertices.length >= 3 && vertices.some((v) => !inside(size, v));
